import React from 'react';

export function OzetKartSkeleton() {
  return (
    <div className="ozet-kart skeleton-pulse">
      <div className="skeleton-line" style={{ width: '40%', height: '14px', marginBottom: '8px' }} />
      <div className="skeleton-line" style={{ width: '60%', height: '28px' }} />
    </div>
  );
}

export function UrunKartSkeleton() {
  return (
    <div className="urun-kart skeleton-pulse">
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px' }}>
        <div className="skeleton-line" style={{ width: '50%', height: '18px' }} />
        <div className="skeleton-line" style={{ width: '20%', height: '18px' }} />
      </div>
      <div className="skeleton-line" style={{ width: '70%', height: '32px', marginBottom: '12px' }} />
      <div className="skeleton-line" style={{ width: '100%', height: '6px', marginBottom: '12px' }} />
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div className="skeleton-line" style={{ width: '30%', height: '14px' }} />
        <div className="skeleton-line" style={{ width: '30%', height: '24px' }} />
      </div>
    </div>
  );
}

export function TabloSatirSkeleton({ kolonSayisi = 5, satirSayisi = 5 }) {
  return (
    <>
      {Array.from({ length: satirSayisi }).map((_, idx) => (
        <tr key={idx} className="skeleton-pulse">
          {Array.from({ length: kolonSayisi }).map((_, cIdx) => (
            <td key={cIdx}>
              <div className="skeleton-line" style={{ width: `${60 + (cIdx * 10) % 35}%`, height: '16px' }} />
            </td>
          ))}
        </tr>
      ))}
    </>
  );
}
